<div>
  <dx-menu
    #menu
    [dataSource]="items"
    displayExpr="name"
    orientation="horizontal"
    [adaptivityEnabled]="true"
    rtlEnabled="true"
    width="100%"
    [hideSubmenuOnMouseLeave]="false"
    (onItemClick)="itemClick($event)"
  >
  </dx-menu>
</div>
